import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=46ec5f28&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ec5f28')) {
      api.createRecord('46ec5f28', component.options)
    } else {
      api.reload('46ec5f28', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=46ec5f28&", function () {
      api.rerender('46ec5f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/Products.vue"
export default component.exports